import React, { FC } from "react";

import { Grid, GridProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledGrid = styled(Grid)(({ theme }) => ({
  width: "100%",
}));

/**
 * @see Grid
 */
export const IgFullWidthGrid: FC<GridProps> = (props) => {
  const { children, ...rest } = props;
  return <StyledGrid {...rest}>{children}</StyledGrid>;
};
